import React, {
  useState,
  memo,
  Fragment,
  useEffect,
  useMemo,
  useContext,
} from "react";
import { useTable, useExpanded } from "react-table";
import { useHistory, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _, { isArray, result } from "lodash";
import classNames from "classnames";
import { format, differenceInDays, getDaysInYear } from "date-fns";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import "react-toastify/dist/ReactToastify.css";
import numeral from "numeral";
import Skeleton from "react-loading-skeleton";
import {
  getCurrentLocalDateTime,
  pad,
  months,
} from "../../../utils/getLocalDateTime";
import { getDifferenceInDays } from "Leasing/util";
import { getInstallmentDueDate } from "Leasing/util";
import { getInstallmentBillDate } from "Leasing/util";
import { calculatePayPerMonth } from "Leasing/util";
import { daysInYear } from "Leasing/util";
import { Auth, Storage } from "aws-amplify";
import { getAsk } from "Leasing/util";
import LoadingPage from "../../Loading/LoadingPage";
import moment from "moment";
import {
  ChevronDownIcon,
  ChevronDoubleRightIcon,
  ChevronRightIcon,
  PlusSmIcon,
  MinusSmIcon,
} from "@heroicons/react/outline";
import FootageRowInfo from "./leasing.f.rowinfo";
import {
  getDiffRemain,
  getSysUpdateBy,
  calPaidRemain,
  calTotalLeasing,
  getTotalNTF,
  getPaidTotalNTF,
  getFormatDate,
} from "../utils/leasing.u";
import {
  prePrincipleColor,
  preInterestColor,
  preLateColor,
  prePaidColor,
  columnSticky,
  prePaidAllColor,
  prePaidRemainAfterColor,
  preOverflow,
} from "../constrant/leasing.ct";
import API from "../api/api.main";
import { ReversePaymentContext } from "../context/leasing.ctx.reversePayment";

const columnPreInstallments = [
  {
    accessor: "expander",
  },
  {
    accessor: "period",
    render: ({ pre_installment }) => {
      return <div className="">{pre_installment.period}</div>;
    },
  },
  {
    accessor: "dueDate",
    render: ({ pre_installment }) => {
      return <div>{getFormatDate(pre_installment.dueDate)}</div>;
    },
  },
  {
    accessor: "beginDate",
    render: ({ pre_installment, pre_installment_index, index }) => {
      return <div>{getFormatDate(pre_installment.beginDate)}</div>;
    },
  },
  {
    accessor: "billCutOffDate",
    render: ({ pre_installment }) => {
      return <div>{getFormatDate(pre_installment.billCutOffDate)}</div>;
    },
  },
  {
    accessor: "beginDatePenalty",
    render: ({ pre_installment, pre_installment_index, index }) => {
      return <div>{getFormatDate(pre_installment.beginDatePenalty)}</div>;
    },
  },
  {
    accessor: "billCutOffDatePenalty",
    render: ({ pre_installment, pre_installment_index, index }) => {
      return <div>{getFormatDate(pre_installment.billCutOffDatePenalty)}</div>;
    },
  },
  {
    accessor: "duration",
    render: ({ pre_installment }) => {
      return (
        <div className="flex justify-center w-10">
          <div className=""> {pre_installment.duration} /</div>
          <div className={classNames(preLateColor)}>
            {" "}
            {pre_installment.durationPenalty}
          </div>
        </div>
      );
    },
  },
  {
    accessor: "capitalRemain",
    render: ({ pre_installment }) => {
      return (
        <div>
          {numeral(pre_installment?.planCapitalRemain).format("0,0.00")}
        </div>
      );
    },
  },
  {
    accessor: "actualCapitalRemain",
    render: ({ pre_installment }) => {
      return (
        <div>
          {numeral(pre_installment?.actualCapitalRemain).format("0,0.00")}
        </div>
      );
    },
  },
  {
    accessor: "principle",
    render: ({ pre_installment }) => {
      return <div>{numeral(pre_installment?.principle).format("0,0.00")} </div>;
    },
  },
  {
    accessor: "principleRemain",
    render: ({ pre_installment }) => {
      const diffPrincipleRemain = getDiffRemain(
        pre_installment?.principle,
        pre_installment.paidPrinciple
      );

      return (
        <div className={prePrincipleColor}>
          {numeral(diffPrincipleRemain < 0 ? 0 : diffPrincipleRemain).format(
            "0,0.00"
          )}{" "}
        </div>
      );
    },
  },
  {
    accessor: "principle_vat",
    render: ({ pre_installment }) => {
      return (
        <div>{numeral(pre_installment?.principle_vat).format("0,0.00")} </div>
      );
    },
  },
  {
    accessor: "principleVatRemain",
    render: ({ pre_installment }) => {
      const diffPrincipleRemain = getDiffRemain(
        pre_installment?.principle_vat,
        pre_installment.paidPrincipleVat
      );

      return (
        <div className={prePrincipleColor}>
          {numeral(diffPrincipleRemain < 0 ? 0 : diffPrincipleRemain).format(
            "0,0.00"
          )}{" "}
        </div>
      );
    },
  },
  {
    accessor: "interest",
    render: ({ pre_installment }) => {
      return (
        <div className="">
          <span>{numeral(pre_installment?.interest).format("0,0.00")}</span>
        </div>
      );
    },
  },
  {
    accessor: "before_interest",
    render: ({ pre_installment }) => {
      return (
        <div className="">
          <span>
            {numeral(pre_installment?.before_interest).format("0,0.00")}
          </span>
        </div>
      );
    },
  },
  {
    accessor: "interestRemain",
    render: ({ pre_installment }) => {
      return (
        <div className={preInterestColor}>
          {numeral(
            getDiffRemain(
              pre_installment?.interest,
              pre_installment.paidInterest
            )
          ).format("0,0.00")}{" "}
        </div>
      );
    },
  },
  {
    accessor: "interest_vat",
    render: ({ pre_installment }) => {
      return (
        <div>
          <span>{numeral(pre_installment?.interest_vat).format("0,0.00")}</span>
        </div>
      );
    },
  },
  {
    accessor: "interestVatRemain",
    render: ({ pre_installment }) => {
      return (
        <div className={preInterestColor}>
          {numeral(
            getDiffRemain(
              pre_installment?.interest_vat,
              pre_installment.paidInterestVat
            )
          ).format("0,0.00")}{" "}
        </div>
      );
    },
  },
  {
    accessor: "penalty",
    render: ({ pre_installment }) => {
      return <div>{numeral(pre_installment?.penalty).format("0,0.00")}</div>;
    },
  },
  {
    accessor: "penaltyRemain",
    render: ({ pre_installment }) => {
      return (
        <div className={preLateColor}>
          {numeral(
            getDiffRemain(pre_installment?.penalty, pre_installment.paidPenalty)
          ).format("0,0.00")}{" "}
        </div>
      );
    },
  },
  {
    accessor: "demand_fee",
    render: ({ pre_installment }) => {
      return <div>{numeral(pre_installment?.demand_fee).format("0,0.00")}</div>;
    },
  },
  {
    accessor: "demand_fee_remain",
    render: ({ pre_installment }) => {
      return (
        <div className={preLateColor}>
          {numeral(
            getDiffRemain(
              pre_installment?.demand_fee,
              pre_installment.paidDemandFee
            )
          ).format("0,0.00")}{" "}
        </div>
      );
    },
  },
  {
    accessor: "visit_fee",
    render: ({ pre_installment }) => {
      return (
        <div className={classNames("w-16")}>
          {numeral(pre_installment?.visit_fee).format("0,0.00")}{" "}
        </div>
      );
    },
  },
  {
    accessor: "visit_fee_remain",
    render: ({ pre_installment }) => {
      return (
        <div className={classNames(preLateColor, "w-16")}>
          {numeral(
            getDiffRemain(
              pre_installment.visit_fee,
              pre_installment.paidVisitFee
            )
          ).format("0,0.00")}{" "}
        </div>
      );
    },
  },
  {
    accessor: "remain_before",
    render: ({ pre_installment }) => {
      return (
        <div className={""}>
          {numeral(getTotalNTF(pre_installment)).format("0,0.00")}
        </div>
      );
    },
  },
  {
    accessor: "remain_after",
    render: ({ pre_installment, loan }) => {
      let totalLeasing = calTotalLeasing(pre_installment, loan);
      if (totalLeasing < 0) {
        totalLeasing = 0;
      }

      return (
        <div className={prePaidRemainAfterColor}>
          {numeral(totalLeasing).format("0,0.00")}
        </div>
      );
    },
  },
  {
    accessor: "total_paid",
    render: ({ pre_installment, loan }) => {
      return (
        <div className={prePaidAllColor}>
          {numeral(getPaidTotalNTF(pre_installment)).format("0,0.00")}
        </div>
      );
    },
  },
  {
    Header: "ชำระล่วงหน้า",
    accessor: "paidOverflow",
    render: ({ pre_installment }) => {
      return (
        <div className={classNames(preOverflow, "w-16")}>
          {numeral(pre_installment.paidOverflow).format("0,0.00")}
        </div>
      );
    },
  },
  {
    accessor: "paidPrinciple",
    render: ({ pre_installment }) => {
      let paidPrinciple = pre_installment.paidPrinciple;
      if (pre_installment.pre_type === "OVERFLOW") {
        paidPrinciple = 0;
      }

      return (
        <div className={prePrincipleColor}>
          {numeral(paidPrinciple).format("0,0.00")}
        </div>
      );
    },
  },
  {
    Header: "ภาษี",
    accessor: "paidPrincipleVat",
    render: ({ pre_installment }) => {
      let paidPrincipleVat = pre_installment.paidPrincipleVat;
      if (pre_installment.pre_type === "OVERFLOW") {
        paidPrincipleVat = 0;
      }

      return (
        <div className={prePrincipleColor}>
          {numeral(paidPrincipleVat).format("0,0.00")}
        </div>
      );
    },
  },
  {
    Header: "ชำระดอกเบี้ย",
    accessor: "paidInterest",
    render: ({ pre_installment }) => {
      return (
        <div className={preInterestColor}>
          {numeral(pre_installment.paidInterest).format("0,0.00")}
        </div>
      );
    },
  },
  {
    Header: "ภาษี",
    accessor: "paidInterestVat",
    render: ({ pre_installment }) => {
      return (
        <div className={preInterestColor}>
          {numeral(pre_installment.paidInterestVat).format("0,0.00")}
        </div>
      );
    },
  },
  {
    Header: "ชำระดอกเบี้ยผิดนัด",
    accessor: "paidPenalty",
    render: ({ pre_installment }) => {
      return (
        <div className={preLateColor}>
          {numeral(pre_installment.paidPenalty).format("0,0.00")}
        </div>
      );
    },
  },
  {
    Header: "ชำระค่าท่วงถาม",
    accessor: "paidDemandFee",
    render: ({ pre_installment }) => {
      return (
        <div className={preLateColor}>
          {numeral(pre_installment.paidDemandFee).format("0,0.00")}
        </div>
      );
    },
  },
  {
    Header: "ชำระค่าลงพื้นที่",
    accessor: "paidVisitFee",
    render: ({ pre_installment }) => {
      return (
        <div className={classNames(preLateColor, "w-16")}>
          {numeral(pre_installment.paidVisitFee).format("0,0.00")}
        </div>
      );
    },
  },
  {
    accessor: "paidDate",
    render: ({ pre_installment }) => {
      return <div>{getFormatDate(pre_installment.paidDate)}</div>;
    },
  },
  {
    accessor: "sys_update_by",
    render: ({ pre_installment }) => {
      return (
        <div className="text-center w-16 flex flex-items flex-col">
          <div>{getSysUpdateBy(pre_installment)}</div>
          <div> {getFormatDate(pre_installment.pre_due_date)} </div>
        </div>
      );
    },
  },
  {
    accessor: "displayStatus",
    render: ({ pre_installment }) => {
      return <div>{pre_installment.displayStatus}</div>;
    },
  },
  {
    accessor: "total",
    render: ({ pre_installment, localIsPlus, isPlus, onClickIsPlus, loan }) => {
      return (
        <div className="flex items-center justify-center space-x-1">
          <div className="flex flex-col">
            <div>
              {pre_installment.pre_status !== "PENDING"
                ? "0.00"
                : numeral(calTotalLeasing(pre_installment, loan)).format(
                    "0,0.00"
                  )}
            </div>
            <div>
              {pre_installment.pre_status !== "PENDING"
                ? "0.00"
                : numeral(
                    Math.ceil(calTotalLeasing(pre_installment, loan))
                  ).format("0,0.00")}
            </div>
          </div>
          <div></div>
          {!isPlus && pre_installment.pre_status === "PENDING" && (
            <div>
              {localIsPlus ? (
                <PlusSmIcon
                  onClick={() => onClickIsPlus(false)}
                  className="w-4 h-4 text-blue-400 cursor-pointer"
                />
              ) : (
                <MinusSmIcon
                  onClick={() => onClickIsPlus(true)}
                  className="w-4 h-4 text-red-400 cursor-pointer"
                />
              )}
            </div>
          )}
        </div>
        //
      );
    },
  },
];

function FootageTableInfo({
  loan,
  installments,
  setInstallments,
  loading,
  isPlus,
  setIsPlus,
  setListIsPlus,
  listIsPlus,
  headerTotal,
  setHeaderTotal,
  onClickIsPlus,
}) {
  const { openReverse } = useContext(ReversePaymentContext);

  const columnFilter = (column) => {
    if (loan?.category === "NTF") {
      return ![
        "visit_fee",
        "visit_fee_remain",
        "paidVisitFee",
        "paidInterestVat",
        "paidPrincipleVat",
        "principle_vat",
        "principleVatRemain",
        "interest_vat",
        "interestVatRemain",
        "before_interest",
      ].includes(column.accessor);
    }

    if (loan?.category === "TF") {
      if (loan?.close_total === 0) {
        return !["before_interest"].includes(column.accessor);
      }
    }

    return column;
  };

  const columns = useMemo(() => {
    let localColumn = [
      {
        id: "expander",
        Cell: ({ row }) => {
          if (row?.original?.pre_installments.length > 0) {
            return (
              <div {...row.getToggleRowExpandedProps()} className="w-2">
                {row.isExpanded ? (
                  <ChevronDownIcon className="w-4 h-4" />
                ) : (
                  <ChevronRightIcon className="w-4 h-4" />
                )}
              </div>
            );
          }
          return null;
        },
      },
      {
        Header: "งวด",
        accessor: "period",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }
          return (
            <div className="w-8 sticky left-0 top-0 font-bold">{row.original.period}</div>
          );
        },
      },
      {
        Header: "วันที่ครบกำหนด",
        accessor: "dueDate",
        Cell: ({ row }) => {
          return (
            <div className="w-20">{getFormatDate(row.original.dueDate)}</div>
          );
        },
      },
      {
        Header: "วันที่เริ่มคิดดอกเบี้ย",
        accessor: "beginDate",
        Cell: ({ row }) => {
          return (
            <div className="w-20">{getFormatDate(row.original.beginDate)}</div>
          );
        },
      },
      {
        Header: "วันที่สิ้นสุดคิดดอกเบี้ย",
        accessor: "billCutOffDate",
        Cell: ({ row }) => {
          return (
            <div className="w-20">
              {getFormatDate(row.original.billCutOffDate)}
            </div>
          );
        },
      },
      {
        Header: "วันที่เริ่มผิดนัด",
        accessor: "beginDatePenalty",
        Cell: ({ row }) => {
          return (
            <div className="w-20">
              {getFormatDate(row.original.beginDatePenalty)}
            </div>
          );
        },
      },
      {
        Header: "วันที่สิ้นสุดผิดนัด",
        accessor: "billCutOffDatePenalty",
        Cell: ({ row }) => {
          return (
            <div className="w-20">
              {getFormatDate(row.original.billCutOffDatePenalty)}
            </div>
          );
        },
      },
      {
        Header: "จำนวนวัน",
        accessor: "duration",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className="flex justify-center w-10">
              <div className=""> {row.original.duration} /</div>
              <div className={classNames(preLateColor)}>
                {" "}
                {row.original.durationPenalty}
              </div>
            </div>
          );
        },
      },
      {
        Header: "เงินต้นคงเหลือ",
        accessor: "capitalRemain",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className="w-20">
              {numeral(row.original?.planCapitalRemain).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "เงินต้นคงเหลือหลังจ่าย",
        accessor: "actualCapitalRemain",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className="w-20">
              {numeral(row.original?.actualCapitalRemain).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "เงินต้น",
        accessor: "principle",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className="w-16">
              {numeral(row.original?.principle).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "เงินต้นคงเหลือ",
        accessor: "principleRemain",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          let diffPrincipleRemain = getDiffRemain(
            row.original.principle,
            row.original.paidPrinciple
          );

          return (
            <div className={classNames(prePrincipleColor, "w-16")}>
              {numeral(
                diffPrincipleRemain < 0 ? 0 : diffPrincipleRemain
              ).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ภาษีเงินต้น",
        accessor: "principle_vat",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className="w-16">
              {numeral(row.original?.principle_vat).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ภาษีเงินต้นคงเหลือ",
        accessor: "principleVatRemain",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          let diffPrincipleRemain = getDiffRemain(
            row.original.principle_vat,
            row.original.paidPrincipleVat
          );

          return (
            <div className={classNames(prePrincipleColor, "w-16")}>
              {numeral(
                diffPrincipleRemain < 0 ? 0 : diffPrincipleRemain
              ).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ดอกเบี้ย",
        accessor: "interest",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames("w-16")}>
              {numeral(row.original?.interest).format("0,0.00")}{" "}
            </div>
          );
        },
      },
      {
        Header: "ดอกเบี้ยก่อนชำระ",
        accessor: "before_interest",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames("w-16")}>
              {numeral(row.original?.before_interest).format("0,0.00")}{" "}
            </div>
          );
        },
      },
      {
        Header: "ดอกเบี้ยคงเหลือ",
        accessor: "interestRemain",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(preInterestColor, "w-16")}>
              {numeral(
                getDiffRemain(row.original.interest, row.original.paidInterest)
              ).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ภาษีดอกเบี้ย",
        accessor: "interest_vat",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames("w-16")}>
              {numeral(row.original?.interest_vat).format("0,0.00")}{" "}
            </div>
          );
        },
      },
      {
        Header: "ภาษีดอกเบี้ยคงเหลือ",
        accessor: "interestVatRemain",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(preInterestColor, "w-16")}>
              {numeral(
                getDiffRemain(
                  row.original.interest_vat,
                  row.original.paidInterestVat
                )
              ).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ดอกเบี้ยผิดนัด",
        accessor: "penalty",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames("w-16")}>
              {numeral(row.original?.penalty).format("0,0.00")}{" "}
            </div>
          );
        },
      },
      {
        Header: "ดอกเบี้ยผิดนัดคงเหลือ",
        accessor: "penaltyRemain",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(preLateColor, "w-16")}>
              {numeral(
                getDiffRemain(row.original.penalty, row.original.paidPenalty)
              ).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ค่าทวงถาม",
        accessor: "demand_fee",
        Cell: ({ row }) => {
          return (
            <div className={classNames("w-16")}>
              {numeral(row?.original?.demand_fee).format("0,0.00")}{" "}
            </div>
          );
        },
      },
      {
        Header: "ค่าทวงถามคงเหลือ",
        accessor: "demand_fee_remain",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(preLateColor, "w-16")}>
              {numeral(
                getDiffRemain(
                  row.original.demand_fee,
                  row.original.paidDemandFee
                )
              ).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ค่าลงพื้นที่",
        accessor: "visit_fee",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames("w-16")}>
              {numeral(row.original?.visit_fee).format("0,0.00")}{" "}
            </div>
          );
        },
      },
      {
        Header: "ค่าลงพื้นที่คงเหลือ",
        accessor: "visit_fee_remain",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(preLateColor, "w-16")}>
              {numeral(
                getDiffRemain(row.original.visit_fee, row.original.paidVisitFee)
              ).format("0,0.00")}{" "}
            </div>
          );
        },
      },
      {
        Header: "คงเหลือก่อนชำระ",
        accessor: "remain_before",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames("", "w-16")}>
              {numeral(getTotalNTF(row?.original)).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "คงเหลือหลังชำระ",
        accessor: "remain_after",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          const totalLeasing = calTotalLeasing(row?.original, loan);

          return (
            <div className={classNames(prePaidRemainAfterColor, "w-16")}>
              {numeral(totalLeasing < 0 ? 0 : totalLeasing).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ชำระ",
        accessor: "total_paid",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(prePaidAllColor, "w-16")}>
              {numeral(getPaidTotalNTF(row.original)).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ชำระล่วงหน้า",
        accessor: "paidOverflow",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(preOverflow, "w-16")}>
              {numeral(row.original.paidOverflow).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ชำระเงินต้น",
        accessor: "paidPrinciple",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(prePrincipleColor, "w-16")}>
              {numeral(row.original.paidPrinciple).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ชำระภาษี",
        accessor: "paidPrincipleVat",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(prePrincipleColor, "w-16")}>
              {numeral(row.original.paidPrincipleVat).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ชำระดอกเบี้ย",
        accessor: "paidInterest",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(preInterestColor, "w-16")}>
              {numeral(row.original.paidInterest).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ชำระภาษี",
        accessor: "paidInterestVat",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(preInterestColor, "w-16")}>
              {numeral(row.original.paidInterestVat).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ชำระดอกเบี้ยผิดนัด",
        accessor: "paidPenalty",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(preLateColor, "w-16")}>
              {numeral(row.original.paidPenalty).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ชำระค่าท่วงถาม",
        accessor: "paidDemandFee",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(preLateColor, "w-16")}>
              {numeral(row.original.paidDemandFee).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "ชำระค่าลงพื้นที่",
        accessor: "paidVisitFee",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className={classNames(preLateColor, "w-16")}>
              {numeral(row.original.paidVisitFee).format("0,0.00")}
            </div>
          );
        },
      },
      {
        Header: "วันที่จ่าย",
        accessor: "paidDate",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className="w-14">{getFormatDate(row.original.paidDate)}</div>
          );
        },
      },
      {
        Header: "UpdateBy",
        accessor: "sys_update_by",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          return (
            <div className="text-center w-16 flex flex-items flex-col">
              <div>{getSysUpdateBy(row.original)}</div>
              <div> {getFormatDate(row.original?.pre_due_date)} </div>
            </div>
          );
        },
      },
      {
        Header: "สถานะ",
        accessor: "displayStatus",
        Cell: ({ row }) => {
          if (!row.original?.pre_installments?.length) {
            return null;
          }

          return <div>{row.original?.displayStatus} </div>;
        },
      },
      {
        Header: () => {
          return (
            <div className="flex flex-col">
              <div className="flex items-center justify-center space-x-1">
                <div>รวม</div>
                <div>
                  {isPlus ? (
                    <PlusSmIcon
                      onClick={() => onClickIsPlus(false)}
                      className="w-4 h-4 text-blue-400 cursor-pointer"
                    />
                  ) : (
                    <MinusSmIcon
                      onClick={() => onClickIsPlus(true)}
                      className="w-4 h-4 text-red-400 cursor-pointer"
                    />
                  )}
                </div>
              </div>
              {!isPlus && <div>{numeral(headerTotal).format("0,0.00")}</div>}
            </div>
          );
        },
        accessor: "total",
        Cell: ({ row }) => {
          if (!row.original.pre_installments.length) {
            return null;
          }

          const onClickIsPlus = (is_true) => {
            setListIsPlus((prev) => {
              let temp = [...prev];

              const findIndex = temp.findIndex(
                (item) => item._id === row.original._id
              );

              if (findIndex !== -1) {
                temp[row.index].isPlus = is_true;
              }

              return temp;
            });

            if (!is_true) {
              setHeaderTotal(
                (prev) => prev + calTotalLeasing(row.original, loan)
              );
            } else {
              setHeaderTotal(
                (prev) => prev - calTotalLeasing(row.original, loan)
              );
            }
          };

          const findListIsPlusIndex = () => {
            const findIndex = listIsPlus.findIndex(
              (item) => item._id === row.original._id
            );

            if (findIndex !== -1) {
              return listIsPlus[findIndex].isPlus;
            }
            return true;
          };

          return (
            <div className="flex items-center justify-center space-x-1 w-24">
              <div className="flex flex-col">
                <div>
                  {numeral(
                    Math.ceil(calTotalLeasing(row.original, loan))
                  ).format("0,0.00")}
                </div>
                <div>
                  {numeral(calTotalLeasing(row.original, loan)).format(
                    "0,0.00"
                  )}
                </div>
              </div>
              {!isPlus && row.original?.pre_status === "PENDING" && (
                <div>
                  {findListIsPlusIndex() ? (
                    <PlusSmIcon
                      onClick={() => onClickIsPlus(false)}
                      className="w-4 h-4 text-blue-400 cursor-pointer"
                    />
                  ) : (
                    <MinusSmIcon
                      onClick={() => onClickIsPlus(true)}
                      className="w-4 h-4 text-red-400 cursor-pointer"
                    />
                  )}
                </div>
              )}
            </div>
          );
        },
      },
    ];

    localColumn = localColumn.filter(columnFilter);
    return localColumn;
  }, [loan, installments, isPlus, listIsPlus, headerTotal]);

  const getInitialExpanded = () => {
    let initialExpanded = {};
    if (installments?.length > 0) {
      for (let index = 0; index < installments.length; index++) {
        const installment = installments[index];
        if (installment.disabledPeriod) {
          continue;
        }
        if (installment?.pre_installments?.length > 1 || index === 0) {
          let last_pre_installment =
            installment?.pre_installments[
              installment?.pre_installments.length - 1
            ];
          const findPrePare = installment.pre_installments.find(
            (pre_installment) =>
              pre_installment.pre_status === "PENDING" &&
              !installment.disabledPeriod
          );
          if (
            (findPrePare && getPaidTotalNTF(last_pre_installment, loan) > 0) ||
            index === 0
          ) {
            initialExpanded = {
              ...initialExpanded,
              [index]: true,
            };
          }
        }
      }
    }
    return initialExpanded;
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    visibleColumns,
    state: { expanded },
  } = useTable(
    {
      columns: columns,
      data: installments,
      initialState: {
        expanded: getInitialExpanded(),
      },
    },
    useExpanded
  );

  if (loading) {
    return (
      <div className="p-4">
        <Skeleton height={32} count={20} />
      </div>
    );
  }

  return (
    <table
      {...getTableProps()}
      className={classNames(" relative table-fixed", {
        "mb-40": openReverse,
      })}
    >
      <thead className="top-0 z-50 text-xs font-semibold tracking-wide text-gray-500 border-blue-400  border-b dark:border-gray-700 bg-white dark:text-gray-400 dark:bg-gray-800">
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()} className="">
            {headerGroup.headers.map((column, i) => {
              return (
                <th
                  className={classNames(
                    "px-4 py-3 text-blue-500 text-center text-xs",
                    {
                      "rounded-tl": i === 0,
                      "rounded-tr": i === headerGroup.headers.length - 1,
                      "px-0": column.id === "expander",
                      // [columnSticky]: column.id === "period",
                    }
                  )}
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                </th>
              );
            })}
          </tr>
        ))}
      </thead>
      <tbody
        className="bg-white divide-y divide-solid divide-gray-300  dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
        {...getTableBodyProps()}
      >
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <FootageRowInfo
              isExpanded={row.isExpanded}
              //   isHilight={i === currentIndex(rows)}
              isDisabled={row.original.disabledPeriod}
              key={row.getRowProps().key}
              i={i}
              row={row}
              visibleColumns={visibleColumns}
              columnPreInstallments={columnPreInstallments.filter(columnFilter)}
              isPlus={isPlus}
              setHeaderTotal={setHeaderTotal}
              headerTotal={headerTotal}
              loan={loan}
              expanded={expanded}
            />
          );
        })}
      </tbody>
    </table>
  );
}

export default FootageTableInfo;
